import axios from "axios";

import { IP } from "../utils/Host";


export function updatePrzeniesWykonanieDoInnejGrupyGant(global_id_wykonania,grupa_id_drop,fechparametryTechnologii, ostatnie_wykonania,zamowienie_id,refreshGantAll) {

// id = procesor id
console.log(global_id_wykonania)
console.log(grupa_id_drop)
console.log(ostatnie_wykonania)

  axios.get(IP + "updatePrzeniesWykonanieDoInnejGrupy/"+global_id_wykonania+"/"+grupa_id_drop+"/"+ostatnie_wykonania)
    .then((res) => {

    fechparametryTechnologii(zamowienie_id,res.data[0].technologia_id)

    }).then((res) => {

    refreshGantAll()

    });
}
